import { useTRPC } from "../../../../trpc/client";
import { useMerchant } from "../../../../hooks/useMerchant";
import { useQuery } from "@tanstack/react-query";

type Props = {
  date: string;
  cycle: string;
};

export function useSettlementInvoices(props: Props | undefined) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const query = useQuery(
    trpc.invoices.list.queryOptions(
      {
        rentalsMerchantId: merchant?.id || "",
        settlementDate: props?.date || "",
        settlementTime: props?.cycle || "",
      },
      {
        enabled: !!merchant?.id && !!props?.date && !!props?.cycle,
      }
    )
  );

  return {
    invoices: query.data?.invoices ?? [],
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
